export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-1.0.0',
    name: 'JDSDropdownMenuInternal'
  },
  hierarchy: {
    'menu-container': [
      {
        'search-container': ['jds_search_box']
      },
      {
        'menu-group-container': ['menu-group-slot']
      },
      {
        'botton-container': [
          'secondary-jds_action_button',
          'primary-jds_action_button'
        ]
      }
    ]
  },
  base: {
    'menu-container': {
      hidden: false,
      'background-color': '{primaryGrey20}',
      'flex-direction': '{flexDirection.column}',
      'border-radius': '{large}',
      'pointer-events': 'auto',
      overflow: 'hidden',
      opacity: '{opacity.invisible}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '{custom_color_5}'
      }
    },
    jds_search_box: {
      prefix: 'ic_search',
      kind: 'light_background',
      width: '{size.max}'
    },
    'menu-group-container': {
      hidden: false,
      width: '{size.max}',
      'flex-direction': '{flexDirection.column}',
      'padding-top': '{xs}',
      'padding-bottom': '{xs}',
      'overflow-y': 'auto'
    },
    'search-container': {
      hidden: true,
      width: '{size.max}',
      'padding-top': '{base}',
      'padding-left': '{base}',
      'padding-right': '{base}'
    },
    'menu-group-slot': {
      hidden: false
    },
    'botton-container': {
      hidden: true,
      width: '{size.max}',
      'padding-top': '{base}',
      'padding-bottom': '{m}',
      'padding-left': '{base}',
      'padding-right': '{base}',
      'flex-direction': '{flexDirection.row}',
      gap: '{s}'
    },
    'primary-jds_action_button': {
      kind: 'primary',
      size: 'medium',
      stretch: true
    },
    'secondary-jds_action_button': {
      kind: 'secondary',
      size: 'medium',
      stretch: true
    }
  },
  variant: {
    menuFullScreen: {
      true: {
        'menu-container': {
          size: '{size.max}'
        }
      }
    },
    _menuContainerVisible: {
      true: {
        'menu-container': {
          opacity: '{opacity.enabled}'
        }
      }
    },
    searchTrigger: {
      true: {
        'search-container': {
          hidden: false
        }
      }
    },
    kind: {
      'multi-select': {
        'botton-container': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      'multi-select': {
        false: {
          'botton-container': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'showCTAButtons']],
  api: {
    children: {
      'menu-group-slot': {
        name: 'children',
        accepts: ['jds_dropdown_menu_group']
      }
    },
    events: {
      jds_search_box: {
        onSuffixClick: 'onSuffixClick',
        onChange: 'onSearchChange'
      },
      'menu-container': {
        onAppear: {
          name: 'onAppear',
          platform: 'ios'
        },
        onClick: 'onContainerClick'
      },
      'secondary-jds_action_button': {
        onClick: 'onSecondaryClick'
      },
      'primary-jds_action_button': {
        onClick: 'onPrimaryClick'
      }
    },
    data: {
      jds_search_box: {
        label: {
          type: 'string',
          name: 'searchLabel'
        },
        value: {
          type: 'string',
          name: 'searchValue'
        },
        suffix: {
          type: 'icon',
          name: 'searchSuffix'
        }
      },
      'menu-container': {
        width: {
          type: 'size',
          name: 'menuWidth'
        },
        elementRef: {
          type: 'ref',
          name: 'triggerRef'
        }
      },
      'menu-group-container': {
        'max-height': {
          type: 'string',
          name: 'menuMaxHeight'
        }
      },
      'primary-jds_action_button': {
        label: {
          type: 'string',
          name: 'primaryCTA'
        }
      },
      'secondary-jds_action_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA'
        }
      }
    },
    config: {
      kind: {
        values: ['single-select', 'multi-select']
      },
      searchTrigger: {
        values: [false, true]
      },
      showCTAButtons: {
        values: [true, false]
      },
      labelTextWrap: {
        values: [false, true]
      },
      open: {
        values: [false, true]
      },
      menuWidthConfig: {
        values: ['max-content', 'trigger']
      },
      position: {
        values: [
          'bottom_start',
          'bottom_end',
          'top_start',
          'top_end',
          'right_start',
          'right_end',
          'left_start',
          'left_end',
          'bottom_centre',
          'top_centre'
        ]
      },
      menuFullScreen: {
        values: [false, true]
      },
      _menuContainerVisible: {
        values: [false, true]
      }
    },
    a11y: {
      'menu-container': {
        properties: {
          role: {
            value: 'menu'
          }
        }
      },
      jds_search_box: {
        properties: {
          ariaLabel: 'searchAriaLabel'
        }
      }
    }
  }
};
